import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useUserUUID } from '@annunciate/core';
import { getEntitlementCacheKey, isEntitledToItem, updateCachedEntitlement, } from '../utils';
export const useIsEntitledQuery = (item) => {
    const client = useQueryClient();
    const uuid = useUserUUID(true);
    const cacheKey = ['entitlement', uuid];
    const { data: entitlementsResults } = useQuery({
        queryKey: cacheKey,
        queryFn: () => {
            return client.getQueryData(cacheKey) || {};
        },
    });
    useEffect(() => {
        updateCachedEntitlement({
            client,
            item,
            uuid,
            entitlements: entitlementsResults?.entitlements || {},
        });
    }, [
        client,
        uuid,
        entitlementsResults?.version,
        item?.id,
        item?.__typename,
    ]);
    const entitlementCacheKey = getEntitlementCacheKey(uuid, item);
    const { data: isEntitled } = useQuery({
        queryKey: entitlementCacheKey,
        queryFn: () => {
            return client.getQueryData(entitlementCacheKey) || false;
        },
        placeholderData: isEntitledToItem({
            item,
            entitlements: entitlementsResults?.entitlements || {},
        }),
    });
    return isEntitled === undefined ? false : isEntitled;
};
//# sourceMappingURL=useIsEntitledQuery.js.map